import { render, staticRenderFns } from "./customerInformation.vue?vue&type=template&id=c8905256&scoped=true&"
import script from "./customerInformation.vue?vue&type=script&lang=js&"
export * from "./customerInformation.vue?vue&type=script&lang=js&"
import style0 from "./customerInformation.vue?vue&type=style&index=0&id=c8905256&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8905256",
  null
  
)

export default component.exports